import { DataService } from "@/services/data";
import { animated, useSpring } from "@react-spring/web";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

type IResult = {
    result: number;
    count: number;
    apprenticeship: {
        result: number;
        count: number;
    };
};

function NumberTransition({ from, to, formatter }: { from: number; to: number; formatter?: (n: number) => string }) {
    // Define the spring animation properties
    const numberProps = useSpring({
        from: { number: from },
        to: { number: to },
        config: { duration: 2500 }
    });

    return <animated.div>{numberProps.number.to(n => (formatter ? formatter(n) : n.toFixed(0)))}</animated.div>;
}

export function DashboardResultPage() {
    let { site } = useParams();

    const refreshInterval = useRef<ReturnType<typeof setInterval>>();
    const [pastResult, setPastResult] = useState<IResult | null>();
    const [result, setResult] = useState<IResult | null>();

    useEffect(() => {
        document.title = `Result | Walter CRM`;
    }, []);

    useEffect(() => {
        refreshResult();
        clearInterval(refreshInterval.current);
        refreshInterval.current = setInterval(() => {
            refreshResult();
        }, 10 * 1000);
        return () => {
            clearInterval(refreshInterval.current);
        };
    }, []);

    const refreshResult = async () => {
        if (site) {
            try {
                const r = (await DataService.client.url(`/tools/dashboard/result/${site}/`).get().json()) as IResult;
                setPastResult(result);
                setResult(r);
            } catch (e) {
                console.error(e);
            }
        }
    };

    return (
        <>
            <div className="container mx-auto flex h-screen items-center justify-center px-4 py-5 lg:px-5 lg:py-10">
                <h1 className="block space-y-3">
                    <div className="flex justify-between">
                        <div className="text-7xl font-semibold text-gray-700">CA du jour</div>
                        <div className="text-7xl font-semibold text-gray-500">
                            {result?.count || 0} vente{(result?.count || 0) > 1 ? "s" : ""}
                        </div>
                    </div>
                    <div className="font-mono text-[13rem] font-bold">
                        <NumberTransition
                            from={pastResult?.result || 0}
                            to={result?.result || 0}
                            formatter={n => {
                                const formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
                                return formatter.format(n);
                            }}
                        />
                    </div>
                    {result?.apprenticeship && result?.apprenticeship.result >= 1000 && result?.apprenticeship.result != result.result && (
                        <div className="flex justify-end">
                            <div className="text-7xl font-semibold text-gray-500">dont {Math.round(result?.apprenticeship.result / 1000)}k€ d'alternance</div>
                        </div>
                    )}
                </h1>
            </div>
        </>
    );
}
